import type { ReactNode } from 'react';
import { useModule } from './useModule';
import { usePerm } from './usePerm';
import type { ModuleKey } from './modules';

/**
 * שער הרשאה. בלי הרשאה: fallback, או כלום.
 * הבדיקה בממשק היא נוחות בלבד; ההגנה האמיתית היא RLS (מסמך התכנון, סעיף 4.2).
 */
export function Gate({
  perm,
  children,
  fallback = null,
}: {
  perm: string;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  return usePerm(perm) ? <>{children}</> : <>{fallback}</>;
}

/**
 * שער מודול. מודול כבוי מחזיר את ה fallback (404 שקט בנתיבים),
 * ולא "אין הרשאה": מבחינת העובד הוא לא קיים.
 */
export function ModuleGate({
  module,
  children,
  fallback = null,
}: {
  module: ModuleKey;
  children: ReactNode;
  fallback?: ReactNode;
}) {
  return useModule(module) ? <>{children}</> : <>{fallback}</>;
}
